import React from 'react'
import cn from 'classnames'
import styled from '@emotion/styled'
import { connect } from 'react-redux'
import Link from 'redux-first-router-link'

import { selectShouldUseDraftsV2 } from 'selectors/app'
import {
  selectIsFacebookTicket,
  selectIsTwitterTicket,
} from 'selectors/tickets'
import { selectIsForwarding, selectIsReplyHeaderExpanded } from 'selectors/page'
import {
  selectOpenExpandedAction,
  selectOpenForwardPageExpandedAction,
  selectOpenNotePageAction,
  selectOpenTicketPageAction,
} from 'selectors/pageActions'
import { Flex, Icon } from 'shared/ui'

import { CannedReplyDropdown } from 'ducks/cannedReplies'
import NavLink from './NavLink'

const NavBar = ({
  actionExpanded,
  className,
  commenting,
  forwarding,
  isExpanded,
  isFacebookTicket,
  isTwitterTicket,
  openForward,
  openNote,
  openReply,
  replying,
  ticketId,
  onExpandClick,
  onReplyClick,
  onForwardClick,
  hideForward,
}) => {
  let expandTo = actionExpanded
  if (onExpandClick) {
    expandTo = null
  }

  return (
    <Flex className={cn(className, { commenting })}>
      <Flex className={className}>
        <NavLink
          className="addReply"
          to={openReply}
          onClick={onReplyClick}
          active={replying && !forwarding}
        >
          Reply
        </NavLink>
        {!hideForward && (
          <NavLink
            className="addForward"
            to={openForward}
            onClick={onForwardClick}
            active={forwarding}
          >
            Forward
          </NavLink>
        )}
        <NavLink
          active={commenting}
          className="addComment"
          type="note"
          to={openNote}
        >
          Note
        </NavLink>
      </Flex>
      {replying && (
        <Flex className={cn('grui justify-end flex-1-0-auto', className)}>
          <CannedReplyDropdown
            ticketId={ticketId}
            isReply={replying}
            isNote={commenting}
          />
          {!isFacebookTicket &&
            !isTwitterTicket && (
              <Link
                className={className}
                to={expandTo}
                onClick={onExpandClick}
                data-test-id="composer-expand-recipients"
              >
                <Icon
                  name="more-horizontal"
                  className="grui ml-4"
                  color={isExpanded ? 'color.primary.brand' : undefined}
                />
              </Link>
            )}
        </Flex>
      )}
    </Flex>
  )
}

const select = state => {
  const usesDraftsV2 = selectShouldUseDraftsV2(state)
  return {
    actionExpanded: selectOpenExpandedAction(state),
    forwarding: selectIsForwarding(state),
    isExpanded: usesDraftsV2 ? false : selectIsReplyHeaderExpanded(state),
    isFacebookTicket: selectIsFacebookTicket(state),
    isTwitterTicket: selectIsTwitterTicket(state),
    openForward: selectOpenForwardPageExpandedAction(state),
    openNote: selectOpenNotePageAction(state),
    openReply: selectOpenTicketPageAction(state),
  }
}

export default connect(select)(styled(NavBar)`
  min-height: 24px;
  &.commenting {
    background-color: ${props => props.theme.color.secondary.warning};
  }

  ${NavLink} + ${NavLink} {
    margin-left: 20px;
  }
`)
